import { Component, Input, OnInit } from "@angular/core";

import { AppService } from "../services/app.service";
import { InterviewService } from "../services/interview.service";
import { Utils } from "../Utils";

interface IRow {
    programId: number;
    programTitle: string;
    examId: number;
    examCode: string;
    notStarted?: number;
    unfinished?: number;
    finished?: number;
    total?: number;
    isCheckable: boolean;
}

interface IColumn {
    title?: string;
    sticky?: boolean;
    sort?: string | ((a: IRow, b: IRow) => number);
    isSorted?: 'asc' | 'desc';
    key?: string;
}

@Component({
    selector: 'app-admission-interviews',
    templateUrl: './admission-interviews.component.html',
    styleUrls: ['./admission-interviews.component.css']
})
export class AdmissionInterviewsComponent implements OnInit {
    constructor(
        public app: AppService,
        private service: InterviewService
    ) {
    }

    @Input() admissionId: number;

    rows: IRow[] = [];
    selectedRows: IRow[] = [];
    targetRowTypes = ['Selected', 'All'];
    publishTarget: string;

    readonly columns: IColumn[] = [
        {}, // check
        { title: 'admissionInterviews_lblExamCode', sort: 'examCode' },
        { title: 'admissionInterviews_lblProgram', sort: 'programTitle' },
        { title: 'admissionInterviews_lblNotStartedCount', sort: 'notStarted' },
        { title: 'admissionInterviews_lblUnfinishedCount', sort: 'unfinished' },
        { title: 'admissionInterviews_lblFinishedCount', sort: 'finished' },
        { title: 'admissionInterviews_lblTotalCount', sort: 'total' }
    ];

    private get checkableRows(): IRow[] {
        return this.rows.filter(t => t.isCheckable);
    }

    ngOnInit() {
        this.load();
    }

    selectRow(item: IRow) {
        if (!item.isCheckable) return;

        const index = this.selectedRows.indexOf(item);

        if (index > -1) this.selectedRows.splice(index, 1);
        else this.selectedRows.push(item);
    }

    selectRows(event) {
        if (event.checked) this.selectedRows = [...this.checkableRows];
        else this.selectedRows = [];
    }

    rowSelected(item: IRow): boolean {
        return this.selectedRows.indexOf(item) > -1;
    }

    allRowsSelected(): boolean {
        return this.selectedRows.length === this.checkableRows.length;
    }

    sort(column: IColumn) {
        if (column.sort) {
            const dir = column.isSorted == undefined || column.isSorted == 'desc' ? 'asc' : 'desc';

            this.columns.forEach(t => (t.isSorted = undefined));
            column.isSorted = dir;

            Utils.sort(this.rows, column.sort, dir);
        }
    }

    publish() {
        const rows = this.publishTarget === 'Selected' ? this.selectedRows : this.checkableRows;

        if (!rows.length) return;

        const loading = this.app.showLoading();

        this.service.publishResults(rows.map(t => { return { ProgramId: t.programId, ExamId: t.examId }; })).then(res => {
            this.app.hideLoading(loading);
            this.app.notify('admissionInterviews_publish_success');
        }, err => this.app.showSaveError(err));
    }

    load() {
        if (!this.admissionId) return;

        const loading = this.app.showLoading();

        this.service.getAdmissionInterviewSummaries(this.admissionId).then(data => {
            this.app.hideLoading(loading);

            this.rows = data.map((t, i) => {
                const row: IRow = {
                    examCode: t.ExamCode,
                    examId: t.ExamId,
                    programId: t.ProgramId,
                    programTitle: t.ProgramTitle,
                    isCheckable: false
                };

                if (t.ExamCode.toLowerCase() == 'int-rz') {
                    row.finished = t.Counts['Finished'] || 0;
                    row.notStarted = (t.Counts['NotStarted'] || 0) + (t.Counts['Absent'] || 0);
                    row.unfinished = t.Counts['Unfinished'] || 0;
                    row.total = row.notStarted + row.unfinished + row.finished;
                    row.isCheckable = true;
                }

                return row;
            });
        }, err => this.app.showLoadError(err));
    }
}
